import { I as IconWrapper, _ as _objectSpread2 } from '../../dist/Icon-3ba184f8.esm.js';
import 'react';
import { jsx } from 'react/jsx-runtime';
import 'styled-components';
import '@lendi-ui/color';

function SvgTwitter(props) {
  return /*#__PURE__*/jsx(IconWrapper, _objectSpread2(_objectSpread2({}, props), {}, {
    children: /*#__PURE__*/jsx("svg", {
      viewBox: "0 0 39.72 39.72",
      fill: "currentColor",
      children: /*#__PURE__*/jsx("path", {
        d: "M19.86 0a19.86 19.86 0 1019.86 19.86A19.88 19.88 0 0019.86 0zm8.86 15.32v.59a13 13 0 01-20 11 9.81 9.81 0 001.09.07 9.17 9.17 0 005.68-2 4.58 4.58 0 01-4.27-3.18 4.82 4.82 0 00.86.09 4.35 4.35 0 001.2-.17 4.56 4.56 0 01-3.67-4.47.11.11 0 010-.06 4.63 4.63 0 002.07.57 4.57 4.57 0 01-2-3.81 4.63 4.63 0 01.62-2.3 13 13 0 009.42 4.78 4.42 4.42 0 01-.12-1 4.58 4.58 0 017.91-3.13 9 9 0 002.91-1.11 4.59 4.59 0 01-2 2.53A8.91 8.91 0 0031 13a9.34 9.34 0 01-2.28 2.37zm0 0"
      })
    })
  }));
}

export { SvgTwitter as default };
